import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';
import ReactSVG from 'react-svg';
import chevron from 'chevron-small.svg';
import ReviewSlider from './ReviewSlider';
import useWindowSize from '../hooks/useWindowSize';
import SquareCard from './SquareCard';
import { CloseLightbox } from './InstagramSlider';

// images is an array of image tag strings
export default function ReviewPhotos({ images }) {
  const [showLightbox, toggleLightbox] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const { width: windowWidth } = useWindowSize();

  return (
    <Fragment>
      <div className="page-review-photos">
        <section className="page-review-photos-header">
          <h3 className="page-section-title">Visitor Photos</h3>
          {images.length > 0 && (
            <div className="view-all">
              <button
                aria-label="View All Review Photos"
                name="View All Review Photos"
                type="button"
                className="secondary-text underline"
                onClick={() => {
                  setImageIndex(0);
                  toggleLightbox(true);
                }}
              >
                View All
              </button>
              <ReactSVG src={chevron} />
            </div>
          )}
        </section>
        {images.length > 0 ? (
          <Fragment>
            {windowWidth > 1010 && images.length >= 4 ? (
              <ReviewSlider
                images={images}
                toggleLightbox={toggleLightbox}
                showLightbox={showLightbox}
                setImageIndex={setImageIndex}
                imageIndex={imageIndex}
              />
            ) : (
              <div className="review-photos-overflow">
                {images.map((image, ind) => (
                  <SquareCard
                    key={ind}
                    image={image.small_image_url || image}
                    toggleLightbox={toggleLightbox}
                    setImageIndex={setImageIndex}
                    index={ind}
                  />
                ))}
                <div className="review-photos-spacer" />
              </div>
            )}
          </Fragment>
        ) : (
          <div className="slider-fallback">
            <p>No Visitor Photos</p>
          </div>
        )}
      </div>
      <Lightbox
        onClose={() => toggleLightbox(false)}
        onClickNext={() => setImageIndex(imageIndex + 1)}
        onClickPrev={() => setImageIndex(imageIndex - 1)}
        currentImage={imageIndex}
        isOpen={showLightbox}
        images={images.map(image => ({
          src: image.large_image_url || image,
        }))}
        onClickThumbnail={e => setImageIndex(e)}
        customControls={[
          <CloseLightbox
            onClick={() => {
              toggleLightbox(false);
              // I'm sorry... There was no other way...
              setTimeout(() => {
                document.querySelector('body').style.overflow = '';
              }, 0);
            }}
          />,
        ]}
        closeButtonTitle="closeLightbox"
        leftArrowTitle="leftLightboxArrow"
        rightArrowTitle="rightLightboxArrow"
        showImageCount={false}
        showThumbnails
      />
    </Fragment>
  );
}

ReviewPhotos.propTypes = {
  images: PropTypes.shape([PropTypes.string]),
};
